(function () {
  var STORAGE_KEY = 'fp_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e) {}
  }

  function isWishlisted(variantId) {
    return getWishlist().indexOf(String(variantId)) !== -1;
  }

  function toggleWishlist(variantId) {
    var list = getWishlist();
    var id = String(variantId);
    var idx = list.indexOf(id);
    if (idx === -1) { list.push(id); } else { list.splice(idx, 1); }
    saveWishlist(list);
    return idx === -1; // true = now wishlisted
  }

  function updateButtonState(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (isWishlisted(vid)) {
      btn.classList.add('is-wishlisted');
      btn.setAttribute('aria-label', 'Remove from wishlist');
    } else {
      btn.classList.remove('is-wishlisted');
      btn.setAttribute('aria-label', 'Save to wishlist');
    }
  }

  function initWishlistButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function(btn) {
      updateButtonState(btn);

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var loggedIn = btn.getAttribute('data-customer-logged-in') === 'true';
        if (!loggedIn) {
          window.location.href = btn.getAttribute('data-login-url');
          return;
        }

        var vid = btn.getAttribute('data-variant-id');
        toggleWishlist(vid);
        updateButtonState(btn);

        // Brief pulse animation
        btn.style.transform = 'scale(1.2)';
        setTimeout(function() { btn.style.transform = ''; }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistButtons);
  } else {
    initWishlistButtons();
  }
})();
